// * LIVE
import content from '@/content/projects/1003-everest-horses'

export default content



// WEBPACK FOOTER //
// ./src/content/index.js